import React from "react";

import { useDialog } from "@/utils/DialogProvider";
import { useTranslation } from "react-i18next";
import DialogContent from "@mui/material/DialogContent";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import { Transition } from "react-transition-group";
import { styled } from "@mui/system";
import ModalClose, { IconButton } from "@mui/material";
import Modal from "@mui/material/Modal";
import { MdDeleteOutline } from "react-icons/md";
import { IoClose } from "react-icons/io5";
// import { DialogContent, DialogTitle } from "@mui/material";
export interface DialogOption {
  open: boolean;
  content: React.ReactNode;
  title: string;
  onClose?: () => void;
}

const DialogContainer: React.FC<DialogOption> = ({ open, content, title }) => {
  const { closeDialog } = useDialog();
  const { t, i18n } = useTranslation();
  const currentLocale = i18n.language as "ar" | "fr" | "en";
  return (
    <Transition in={open} timeout={400}>
      {(state: string) => (
        <Modal
          open={!["exited", "exiting"].includes(state)}
          onClose={closeDialog}
          slotProps={{
            backdrop: {
              sx: {
                opacity: 0,
                backdropFilter: "none",
                transition: `opacity 400ms, backdrop-filter 400ms`,
                ...{
                  entering: { opacity: 1, backdropFilter: "blur(8px)" },
                  entered: { opacity: 1, backdropFilter: "blur(8px)" },
                }[state],
              },
            },
          }}
          sx={{
            visibility: state === "exited" ? "hidden" : "visible",
          }}
        >
          <Dialog
            className={currentLocale == "ar" ? "tright rtl" : ""}
            maxWidth="md"
            sx={{
              opacity: 0,
              transition: `opacity 300ms`,
              ...{
                entering: { opacity: 1 },
                entered: { opacity: 1 },
              }[state],
            }}
            onClose={closeDialog}
            open={!["exited", "exiting"].includes(state)}
          >
            <DialogTitle
              sx={{
                color: "#16489f",
                fontFamily: "Plus Jakarta Sans",
                fontSize: "17px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              {title}
              <IconButton
                onClick={closeDialog}
                aria-label="close"
                sx={{
                  color: "#16489f",
                }}
                size="small"
              >
                <IoClose />
              </IconButton>
            </DialogTitle>

            <DialogContentStyled>{content}</DialogContentStyled>
          </Dialog>
        </Modal>
      )}
    </Transition>
  );
};

export default DialogContainer;

const DialogContentStyled = styled(DialogContent)`
  @media screen and (min-width: 800px) {
    min-width: 500px;
  }
  font-family: "Plus Jakarta Sans", sans-serif;
  font-size: 15px;
  ::-webkit-scrollbar {
    display: none;
  }
`;
// const ModalDialogStyled = styled(ModalDialog)`
//  background-color: white;
// `;
